import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkProps } from 'react-router-dom';

import { InternalLink as IInternalLink } from 'src/api/contentful/contentTypes.cloverdotcom';
import { workaroundRef } from 'src/components/TrackedLink/Util';
import { isChildrenDefined } from 'src/utils/ChildrenCheck';
import { getField, isEntry } from 'src/utils/EntryUtil';
import { getUrlWithParamsOrPdpRedirect, shouldRedirectExistingMerchant } from 'src/utils/ExistingMerchant';

import { testAttribute } from '../../utils/Serenity';
import { applyEntryDataAttributes } from '../EntryWrapper/EntryDataWrapper';
import { IContentLink } from './IContentLink';
import { LocaleLink } from './LocaleLink';

export interface IInternalLinkProps extends IContentLink<IInternalLink>,
  Pick<LinkProps, Exclude<keyof LinkProps, 'to' | 'innerRef' | 'target'>> {
  titleTag?: string;
  dataTestPrefix?: string;
}

const InternalLink: React.FC<IInternalLinkProps> = ({
  innerRef, entry, children, hideTitle, dataTestPrefix, titleTag= 'span', ...props
}) => {
  if (!isEntry(entry)) return null;

  const { t } = useTranslation();

  const { page, queryParameters, title, hint } = entry.fields;

  const slug = getField(page, 'slug');
  const dataTest = dataTestPrefix ? `${dataTestPrefix}-${testAttribute(title)}` : `${testAttribute(title)}`;

  if (!slug) return null;

  const url = getUrlWithParamsOrPdpRedirect(slug, queryParameters);
  const shouldRedirectToPDP = shouldRedirectExistingMerchant(slug);

  const childrenIsValid = isChildrenDefined(children);

  return (
    <LocaleLink innerRef={node => workaroundRef(node, innerRef)} to={url} title={hint || title} data-test={dataTest} {...props}>
      {(shouldRedirectToPDP && !childrenIsValid) && t('contact-sales')}
      {!(shouldRedirectToPDP || hideTitle) && React.createElement(titleTag, '', title)}
      {children}
    </LocaleLink>
  );
};

const Wrapper = applyEntryDataAttributes(InternalLink);
type Wrapper = typeof Wrapper;
export { Wrapper as InternalLink };
